/**
 * Escaping helpers for values interpolated into HTML template literals.
 *
 * Several partials build markup as strings and hand it to jQuery .html() or
 * .append(), both of which parse the string as HTML. AJAX responses carry raw
 * post titles, excerpts and captions, so every server-supplied value must be
 * escaped at that point.
 */

/**
 * Escape a value for use as HTML text or inside a quoted attribute.
 *
 * @param {*} value
 * @return {string}
 */
export const esc = (value) =>
  value == null
    ? ''
    : String(value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');

/**
 * Escape a URL for an href/src attribute.
 *
 * Only absolute http(s), root-relative, hash and query URLs are allowed
 * through, so a javascript: or data: URL cannot execute.
 *
 * @param {*} value
 * @return {string}
 */
export const escUrl = (value) => {
  const url = String(value == null ? '' : value).trim();
  return /^(https?:|\/|#|\?)/i.test(url) ? esc(url) : '';
};
